import { alpha } from '@mui/material/styles';

interface TreedisColors {
  blue: {
    main: string;
    lighter: string;
    lightest: string;
  };
  cyan: {
    main: string;
  };
  pink: {
    main: string;
  };
}

declare module '@mui/material/styles/createPalette' {
  interface TypeBackground {
    neutral: string;
    darker: string;
  }

  interface Palette {
    treedis: TreedisColors;
  }
}

declare module '@mui/material' {
  interface Color {
    0: string;
    500_8: string;
    500_12: string;
    500_16: string;
    500_24: string;
    500_32: string;
    500_48: string;
    500_56: string;
    500_80: string;
  }
}

const PRIMARY = {
  light: '#2055ff', // need a different color
  main: '#2055ff',
  dark: '#2055ff', // need a different color
};
const SECONDARY = {
  light: '#fff',
  main: '#fff',
  dark: '#fff',
};
const INFO = {
  light: '#2055ff',
  main: '#2055ff',
  dark: '#2055ff',
};
const SUCCESS = {
  light: '#E3FFD6',
  main: '#27AE60',
  dark: '#27AE60', // need a different color
};
const WARNING = {
  light: '#FFF4CD',
  main: '#FAAD39',
  dark: '#FAAD39', // need a different color
};
const ERROR = {
  light: '#FFF1EF',
  main: '#F34848',
  dark: '#F34848', // need a different color
};

const GREY = {
  0: '#FFFFFF',
  100: '#F7F7F7',
  200: '#F2F2F2',
  300: '#EBEBEB',
  400: '#BDBDBD',
  500: '#828282',
  600: '#6B6B6B',
  700: '#4F4F4F',
  800: '#333333',
  900: '#000000',
  500_8: alpha('#828282', 0.08),
  500_12: alpha('#828282', 0.12),
  500_16: alpha('#828282', 0.16),
  500_24: alpha('#828282', 0.24),
  500_32: alpha('#828282', 0.32),
  500_48: alpha('#828282', 0.48),
  500_56: alpha('#828282', 0.56),
  500_80: alpha('#828282', 0.8),
};

const COMMON = {
  common: { black: '#000', white: '#fff' },
  primary: { ...PRIMARY, contrastText: '#fff' },
  secondary: { ...SECONDARY, contrastText: '#fff' },
  info: { ...INFO, contrastText: '#fff' },
  success: { ...SUCCESS, contrastText: '#fff' },
  warning: { ...WARNING, contrastText: '#fff' },
  error: { ...ERROR, contrastText: '#fff' },
  grey: GREY,
  treedis: {
    blue: {
      main: '#2055FF',
      lighter: alpha('#2055FF', 0.8),
      lightest: alpha('#2055FF', 0.1),
    },
    cyan: {
      main: '#39F8EA',
    },
    pink: {
      main: '#FD7BF2',
    },
  },
  action: {
    hover: GREY[500_8],
    selected: GREY[500_16],
    disabled: GREY[500_80],
    disabledBackground: GREY[500_24],
    focus: GREY[500_24],
    hoverOpacity: 0.08,
    disabledOpacity: 0.48,
  },
};

const palette = {
  ...COMMON,
  text: { primary: '#fff', secondary: GREY[500], disabled: GREY[600] },
  background: { paper: GREY[800], default: GREY[900], darker: GREY[800] },
  action: { active: GREY[500], ...COMMON.action },
};

export default palette;
